// @ts-nocheck
export const localeCodes =  [
  "it",
  "en",
  "fr"
]
export const localeLoaders = {
  it: [
    {
      key: "locale_it_46ts_32a88854",
      load: () => import("#nuxt-i18n/32a88854" /* webpackChunkName: "locale_it_46ts_32a88854" */),
      cache: true
    }
  ],
  en: [
    {
      key: "locale_en_46ts_57c343c1",
      load: () => import("#nuxt-i18n/57c343c1" /* webpackChunkName: "locale_en_46ts_57c343c1" */),
      cache: true
    }
  ],
  fr: [
    {
      key: "locale_fr_46ts_3f67edb7",
      load: () => import("#nuxt-i18n/3f67edb7" /* webpackChunkName: "locale_fr_46ts_3f67edb7" */),
      cache: true
    }
  ]
}
export const vueI18nConfigs = [
  () => import("#nuxt-i18n/ee4e6a16" /* webpackChunkName: "config_i18n_46config_46ts_ee4e6a16" */)
]
export const normalizedLocales = [
  {
    code: "it",
    name: "IT",
    language: "it-IT",
    isold: "it_IT",
    isCatchallLocale: true,
    _hreflang: "it-IT",
    _sitemap: "it-IT"
  },
  {
    code: "en",
    name: "EN",
    language: "en-GB",
    isold: "en_GB",
    _hreflang: "en-GB",
    _sitemap: "en-GB"
  },
  {
    code: "fr",
    name: "FR",
    language: "fr-FR",
    isold: "fr_FR",
    _hreflang: "fr-FR",
    _sitemap: "fr-FR"
  }
]
/** client **/

/** client-end **/